import { useEffect, useState } from 'react';
import { useConfigurator } from '~/graphql/hooks/use-configurator';
import { CatalogItem } from '~/graphql/mapper';
import { FeatureCategory } from '~/graphql/types';

const multipleChoiceCategories: {
	[K in FeatureCategory]: boolean;
} = {
	// FALSE
	trimline: false,
	driveTrain: false,
	rims: false,
	steeringWheel: false,
	seat: false,
	interiorTile: false,
	bodyPaint: false,
	interiorPackage: false,
	// TRUE
	headlight: true,
	exteriorPaintType: true,
	accessory: true,
	package: true,
	packageFeature: true,
	incentive: true,
};

export function useActiveCard() {
	const { loadingFlags, isItemChecked, changeConfiguration } = useConfigurator();

	const [active, setActive] = useState(-1);

	useEffect(() => {
		setActive(-1);
	}, [loadingFlags.checkingConflicts]);

	return {
		active,
		selectCard: (index: number, item: CatalogItem, trackSelection: () => void) => {
			if (isItemChecked(item)) {
				const isMultipleChoice = multipleChoiceCategories[item.type];
				if (!isMultipleChoice && item.type !== 'interiorPackage') {
					return;
				}
			}
			trackSelection();
			changeConfiguration(item);
			if (!item.status.changeable) {
				console.warn(
					'The selected item is not changeable. Choosing an equivalent item will (probably) replace it.',
					item,
				);
				return;
			}

			setActive(index);
		},
	};
}
